// Vendor imports
const qs = require('qs')
// Sibling imports
const { deeplinkBaseUrlState } = require('./selectors')

// Action types

const DISMISS_OPEN_IN_APP = 'OPEN_IN_APP_DISMISS'

// Action dispatchers

function openInApp() {
  return function (dispatch, getState) {
    const baseUrl = deeplinkBaseUrlState(getState())
    const deeplinkUrl = getDeeplinkUrl(baseUrl)
    location.assign(deeplinkUrl)
  }
}

function dismiss() {
  return function (dispatch) {
    setDismissedCookie()
    dispatch({ type: DISMISS_OPEN_IN_APP })
  }
}

// Helpers

function setDismissedCookie() {
  // Ask again in 1 week
  const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
  require('js-cookie').set('open-in-app-dismissed', '1', { expires })
}

function getDeeplinkUrl(baseUrl) {
  const queryString = qs.stringify({
    'deeplink_url': location.href
  })
  return `${baseUrl}?${queryString}`
}

// Exports

module.exports = {
  // Action types
  DISMISS_OPEN_IN_APP,
  // Action dispatchers
  dismiss,
  openInApp
}
